// export const RPC_URL = "https://ssc-dao.genesysgo.net";
export const RPC_URL = "https://morning-silent-water.solana-mainnet.quiknode.pro/Z5qiBWVpnCNF1nyh2yiUWaH34hZEnENHYf55JLvYtjzK6AiA7Ak8QitVsOWPOHqs/";

export const faqs = [
  { q: "What is Degen Coin Flip (DCF)?", a: "Degen Coin Flip is a smart contract that allows users to play Double or Nothing with their Solana tokens. Odds are 50/50 with a 3.5% fee that goes to DCF NFT holders" },
  { q: "How do I know I can Trust DCF?", a: "DCF has over +1m flips since we started and we are the #1 most trusted platform on Solana.\n\nThe DCF Team and DCF NFT holders' have aligned incentives for the game to have exactly 50/50 odds.\n\nOur House and Fee wallets are all public and every transaction can be reviewed by anyone." },
  { q: "Where can I track transactions?", a: "House Wallet:\nhttps://solscan.io/account/D6X9pm65p7NuWrgrYQUNU1M4qvAA7ASz4GWymGuPYrtw\n\nFee Wallet:\nhttps://solscan.io/account/DAdbcE5SdqoQArf7V87pYR6jPNmTtEUbR2XeC1kAzZjh" },
  { q: "Where can I learn more?", a: "Join us on discord, there will always be someone to help you out.\nhttps://discord.gg/f5JGjGysHU." },
];


export const CHALLENGES = [
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/WtWzHUL.png",
    // "coinImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "logoUrl": "https://i.imgur.com/FjUZXhp.png",
    "name": "Degen",
    "profileImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "url": "https://degencoinflip.com",
    "themes": ["light", "dark"],
    "social": {
      "twitterUrl": "https://twitter.com/degencoinflip",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "wagmi",
    "backgroundImage": "https://i.imgur.com/SKGV8ri.png"
    // "backgroundImage": "https://i.imgur.com/hsJxWO9.png",
    // "backgroundImage": "https://i.imgur.com/jbfFPXY.png",
    // "backgroundImage": "https://i.imgur.com/hsJxWO9.png"
    // "backgroundImage": "https://i.imgur.com/ayJYLJZ.png",
    // "backgroundImage": "https://i.imgur.com/a7PB9qG.jpg"

  },
  {
    "id": "afb2ea05-24d8-47d9-92e6-2cf659b19883",
    "coinImageUrl": "https://i.imgur.com/b8pipWF.png",
    "logoUrl": "https://i.imgur.com/ciLzClZ.jpg",
    "name": "Degen Dex",
    "profileImageUrl": "https://i.imgur.com/b8pipWF.png",
    "url": "https://flip.degendex.io",
    "themes": ["dark", "light"],
    "slug": "degendex",
    "social": {
      "twitterUrl": "https://twitter.com/DegenDex",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/3WcY4JjFeB"
    }
  },
  {
    "id": "2e40f832-9c3f-4c90-b208-43d37afcab95",
    "coinImageUrl": "https://i.imgur.com/PcpvtJg.png",
    "logoUrl": "https://c.tenor.com/caKYaPNBiCQAAAAC/meerkat-mmcc.gif",
    "name": "Meerkat Millionaires",
    "profileImageUrl": "https://i.imgur.com/PcpvtJg.png",
    "url": "https://flip.meerkatmillionaires.club",
    "themes": ["dark", "light"],
    "slug": "mmcc",
    "social": {
      "twitterUrl": "https://twitter.com/mmccsolana",
      "marketplaceUrl": "https://www.magiceden.io/marketplace/meerkat_millionaires_country_club",
      "discordUrl": "https://discord.com/invite/MMCC"
    },
  },
  {
    "id": "bf4c00c6-d5c3-411f-a4e9-eaf07c169ba0",
    "coinImageUrl": "https://i.imgur.com/rXTYGMZ.png",
    "logoUrl": "https://i.imgur.com/rXTYGMZ.png",
    "name": "Solana NFT Radar",
    "profileImageUrl": "https://i.imgur.com/rXTYGMZ.png",
    "url": "https://flip.solnftradar.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/solnftradar",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "http://discord.gg/nftradar"
    },
    "slug": "solnftradar"
  },
  {
    "id": "63a44135-31db-44d8-b539-b62262112f9e",
    "coinImageUrl": "https://i.imgur.com/W8iu5dO.png",
    "logoUrl": "https://i.imgur.com/W8iu5dO.png",
    "name": "Doge Capital",
    "profileImageUrl": "https://i.imgur.com/W8iu5dO.png",
    "url": "https://flip.thedogecapital.com ",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/thedogecapital",
      "marketplaceUrl": "https://magiceden.io/marketplace/doge_capital",
      "discordUrl": "https://discord.com/invite/DeM5VFF29v"
    },
    "slug": "dogecapital"
  },
  {
    "id": "c458b174-676f-4ab2-a7e7-d677ecc61c22",
    "coinImageUrl": "https://i.imgur.com/mcMfLF9.png",
    "logoUrl": "https://i.imgur.com/mcMfLF9.png",
    "name": "Solana Slugs",
    "profileImageUrl": "https://i.imgur.com/mcMfLF9.png",
    "url": "https://flip.solslugs.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/SolSlugsNFT",
      "marketplaceUrl": "https://magiceden.io/marketplace/sol_slugs",
      "discordUrl": "discord.gg/TKpFrWwa"
    },
    "slug": "solslugs"
  },
  {
    "id": "01aa6abe-feb1-48ef-a2b0-bc5618ab81a9",
    "coinImageUrl": "https://i.imgur.com/2KcwYfe.png",
    "logoUrl": "https://i.imgur.com/j07P8tg.gif",
    "name": "Bōryoku Dragonz",
    "profileImageUrl": "https://i.imgur.com/2KcwYfe.png",
    "url": "https://tajfeet.io",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/boryokudragonz",
      "marketplaceUrl": "https://magiceden.io/marketplace/boryoku_dragonz",
      "discordUrl": "https://discord.gg/jSUWCYm3rF"
    },
    "slug": "boryokudragonz"
  },
  {
    "id": "32f5cce2-c9d1-49aa-bf16-e1c24e8fe899",
    "coinImageUrl": "https://i.imgur.com/mv3yDZS.png",
    "logoUrl": "https://i.imgur.com/mv3yDZS.png",
    "name": "Visionary",
    "profileImageUrl": "https://i.imgur.com/mv3yDZS.png",
    "url": "https://flip.visionarystudios.io",
    "themes": ["dark"],
    "backgroundImage": "https://i.imgur.com/dmwMoOc.png",
    "social": {
      "twitterUrl": "http://twitter.com/solanavisionary",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/visionarystudios"
    },
    "slug": "visionary"
  },
  {
    "id": "9e94a921-9518-48bc-84af-fe66de92218c",
    "logoUrl": "https://i.imgur.com/XgwK4k3.png",
    "coinImageUrl": "https://i.imgur.com/XgwK4k3.png",
    "name": "Stoned Ape Crew",
    "profileImageUrl": "https://i.imgur.com/TIIDwy4.jpg",
    "url": "https://sac.degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/stonedapecrew",
      "marketplaceUrl": "https://magiceden.io/marketplace/stoned_ape_crew",
      "discordUrl": "https://discord.gg/stonedapecrew"
    },
    "slug": "stonedapecrew",
    "assets": {
      "coinSideImageUrl": "https://i.imgur.com/F6aXYPK.png",
      "coinProcessingImageUrl": "https://i.imgur.com/yz5A8qk.gif",
      "coinHeadsImageUrl": "https://i.imgur.com/jrEaUha.gif",
      "coinTailsImageUrl": "https://i.imgur.com/wmELBB6.gif",
      "coinProcessingImageUrlIsSquare": true,
      "buttonPt05Sol": "https://i.imgur.com/eLrXikn.png",
      "buttonPt10Sol": "https://i.imgur.com/MkIYyk8.png",
      "buttonPt25Sol": "https://i.imgur.com/caOiPw2.png",
      "buttonPt5Sol": "https://i.imgur.com/FFoJs7n.png",
      "button1Sol": "https://i.imgur.com/Qd6DRX9.png",
      "button2Sol": "https://i.imgur.com/5KCQIxO.png",
      "button3Sol": "https://i.imgur.com/QQRtRol.png",
      "buttonTryAgain": "https://i.imgur.com/lljTgbV.png",
      "buttonClaimReward": "https://i.imgur.com/cPlDGOW.png",
      "buttonPleaseWait": "https://i.imgur.com/Rcd5Lmq.png",
      "buttonDoubleOrNothingOptions": "https://i.imgur.com/eGkRWhu.png",
      "buttonDoubleOrNothing": "https://i.imgur.com/70HeIiN.png",
      "buttonTails": "https://i.imgur.com/Tw8qnd3.png",
      "buttonHeads": "https://i.imgur.com/H70xdGh.png"
    }
  },
  {
    "id": "fc9ab43e-7da5-4922-8874-4df43ad0dcc8",
    "coinImageUrl": "https://i.imgur.com/ioPQRCo.png",
    "logoUrl": "https://i.imgur.com/ioPQRCo.png",
    "name": "FamilySOL NFT",
    "profileImageUrl": "https://i.imgur.com/ioPQRCo.png",
    "url": "https://familysolnft.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/familysolnft",
      "marketplaceUrl": "https://t.co/U2C4HHleSg",
      "discordUrl": "https://t.co/Cf2KDOxEUh"
    },
    "slug": "familysol"
  },
  {
    "id": "926bee35-20a0-4e26-ae13-2c9968b12bd5",
    "coinImageUrl": "https://i.imgur.com/h344RMl.png",
    "logoUrl": "https://i.imgur.com/h344RMl.png",
    "name": "Moshi Heads",
    "profileImageUrl": "https://i.imgur.com/h344RMl.png",
    "url": "https://www.moshiheads.com/",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/Moshiheads",
      "marketplaceUrl": "https://magiceden.io/marketplace/moshiheads_",
      "discordUrl": "http://discord.gg/moshiheads"
    },
    "slug": "moshiheads"
  },
  {
    "id": "ffebf122-08a5-445f-950a-8f6cf2122516",
    "coinImageUrl": "https://i.imgur.com/UsL6Bp1.png",
    "logoUrl": "https://i.imgur.com/UsL6Bp1.png",
    "name": "Chikara Chimps",
    "profileImageUrl": "https://i.imgur.com/UsL6Bp1.png",
    "url": "https://chikara.degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/chikarachimps",
      "marketplaceUrl": "https://t.co/vHEo4JwCih",
      "discordUrl": "https://t.co/azvNytkU7I"
    },
    "slug": "chikara"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/eZyhTUk.png",
    "logoUrl": "https://i.imgur.com/eZyhTUk.png",
    "name": "Degen",
    "profileImageUrl": "https://i.imgur.com/WtWzHUL.png",
    "url": "https://degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/degencoinflip",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "sniper"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/l82dunT.png",
    "logoUrl": "https://i.imgur.com/l82dunT.png",
    "name": "Degen",
    "profileImageUrl": "https://i.imgur.com/WtWzHUL.png",
    "url": "https://degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/degencoinflip",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "jcs"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/0xc03CW.png",
    "logoUrl": "https://i.imgur.com/0xc03CW.png",
    "name": "MetaFrog Business Club",
    "profileImageUrl": "https://i.imgur.com/0xc03CW.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/MetaFrogBizClub",
      "marketplaceUrl": "https://t.co/v4Umo40VUL",
      "discordUrl": "https://t.co/L2pmVkDoNQ"
    },
    "slug": "metafrogs"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/377uQK6.png",
    "logoUrl": "https://i.imgur.com/377uQK6.png",
    "name": "Dino Kingz",
    "profileImageUrl": "https://i.imgur.com/377uQK6.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/DinoKingzNFT",
      "marketplaceUrl": "https://magiceden.io/creators/dinokingz",
      "discordUrl": "http://discord.gg/gFTJTwTWcs"
    },
    "slug": "dinokingz"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/IfUGSC7.png",
    "logoUrl": "https://i.imgur.com/IfUGSC7.png",
    "name": "CyberVillainz",
    "profileImageUrl": "https://i.imgur.com/IfUGSC7.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/CyberVillainz",
      "marketplaceUrl": "https://magiceden.io/marketplace/cybervillainz",
      "discordUrl": "https://discord.gg/eMJRr86VM5"
    },
    "slug": "cybervillainz"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/NRG2xOK.png",
    "logoUrl": "https://i.imgur.com/NRG2xOK.png",
    "name": "S◎L Boss",
    "profileImageUrl": "https://i.imgur.com/NRG2xOK.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/TheSolanaBoss",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "solanaboss"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/cSHTbIl.png",
    "logoUrl": "https://i.imgur.com/cSHTbIl.png",
    "name": "Tamashi Soul",
    "profileImageUrl": "https://i.imgur.com/NRG2xOK.png",
    "themes": ["dark"],
    "social": {
      "twitterUrl": "https://twitter.com/TamashiSoulNFT",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/TamashiSoul"
    },
    "slug": "tamashi",
    "backgroundImage": "https://i.imgur.com/1DVtq5s.jpg"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/ZWGJQZL.png",
    "logoUrl": "https://i.imgur.com/ZWGJQZL.png",
    "name": "Atitty",
    "profileImageUrl": "https://i.imgur.com/ZWGJQZL.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/Atitty_",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "atitty"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/unPJnhX.gif",
    "logoUrl": "https://i.imgur.com/unPJnhX.gif",
    "name": "DCF Microshares",
    "profileImageUrl": "https://i.imgur.com/unPJnhX.gif",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://www.twitter.com/DCF_microshares",
      "marketplaceUrl": "https://magiceden.io/marketplace/dcf_microshares",
      "discordUrl": "https://www.discord.gg/vZsZ7RRApy"
    },
    "slug": "micro"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/d9uF6Bi.png",
    "logoUrl": "https://i.imgur.com/d9uF6Bi.png",
    "name": "SolFP",
    "profileImageUrl": "https://i.imgur.com/d9uF6Bi.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://www.twitter.com/solfp_bot",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/W8syhtpw4G"
    },
    "slug": "solfp"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/pHYyCPv.png",
    "logoUrl": "https://i.imgur.com/pHYyCPv.png",
    "name": "Dope Apes",
    "profileImageUrl": "https://i.imgur.com/pHYyCPv.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/DopeApes",
      "marketplaceUrl": "https://magiceden.io/marketplace/dope_apes",
      "discordUrl": "http://discord.gg/dopeapes"
    },
    "slug": "dopeapes"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/VDsQ4EQ.png",
    "logoUrl": "https://i.imgur.com/VDsQ4EQ.png",
    "name": "Shredded Apes Gym Club",
    "profileImageUrl": "https://i.imgur.com/VDsQ4EQ.png",
    "themes": ["dark"],
    "social": {
      "twitterUrl": "https://twitter.com/ShreddedApesNFT",
      "marketplaceUrl": "https://magiceden.io/marketplace/shredded_apes_gym_club",
      "discordUrl": "https://discord.com/invite/SGyaVNX3CC"
    },
    "backgroundImage": "https://i.imgur.com/wyr2o2e.png",
    "slug": "sagc"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/kW0oyrn.gif",
    "logoUrl": "https://i.imgur.com/kW0oyrn.gif",
    "name": "SolBots",
    "profileImageUrl": "https://i.imgur.com/kW0oyrn.gif",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/SolBotsDAO",
      "marketplaceUrl": "https://magiceden.io/marketplace/solbots",
      "discordUrl": "https://discord.gg/solbots"
    },
    "slug": "solbots"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "logoUrl": "https://i.imgur.com/FjUZXhp.png",
    "name": "Jaylene",
    "profileImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "url": "https://degencoinflip.com",
    "themes": ["dark"],
    "social": {
      "twitterUrl": "https://twitter.com/playmatejaylene",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "jaylene",
    "backgroundImage": "https://i.imgur.com/S2cm9vJ.png",
    "backgroundImageMobile": "https://i.imgur.com/ge9yELk.png",
    "winStreakAssets": [
      "https://i.imgur.com/yaVI61c.jpg",
      "https://i.imgur.com/VGiFD4t.jpg",
      "https://i.imgur.com/B9Xl5jy.jpg",
      "https://i.imgur.com/sRGJMFt.jpg",
      "https://i.imgur.com/Xothh8o.jpg",
      "https://i.imgur.com/aaAKp0b.jpg",
      "https://i.imgur.com/OXIRZLS.jpg",
      "https://i.imgur.com/rqEoey6.jpg",
      "https://i.imgur.com/YteelTB.jpg",
      "https://i.imgur.com/pzCf5gO.jpg",
      "https://i.imgur.com/0y9zxf5.jpg",
      "https://i.imgur.com/SW4NhRj.jpg",
      "https://i.imgur.com/An1OxHZ.jpg",
      "https://i.imgur.com/AnBKUio.jpg",
      "https://i.imgur.com/yeh5MkF.jpg",
      "https://i.imgur.com/8ayvkVb.jpg",
      "https://i.imgur.com/7ALoPlF.jpg",
      "https://i.imgur.com/i0uuKe0.jpg"
    ]
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "logoUrl": "https://i.imgur.com/FjUZXhp.png",
    "name": "nsfw",
    "profileImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "url": "https://degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/playmatejaylene",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "nsfw",
    "backgroundImage": "https://i.imgur.com/MxHBBvx.gif"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "logoUrl": "https://i.imgur.com/FjUZXhp.png",
    "name": "Pixels",
    "profileImageUrl": "https://i.imgur.com/FjUZXhp.png",
    "url": "https://degencoinflip.com",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/playmatejaylene",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "pixels",
    "backgroundImage": "https://i.imgur.com/YtD2nrx.gif"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/LaGEin9.png",
    "logoUrl": "https://i.imgur.com/LaGEin9.png",
    "name": "HIDDEN BOYZ",
    "profileImageUrl": "https://i.imgur.com/LaGEin9.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/hiddenboyznft",
      "marketplaceUrl": "https://magiceden.io/marketplace/solbots",
      "discordUrl": "https://discord.com/invite/hiddenboyz"
    },
    "slug": "hidden"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/fdPWqne.png",
    "logoUrl": "https://i.imgur.com/fdPWqne.png",
    "name": "DISARTICULATED SKULLYS",
    "profileImageUrl": "https://i.imgur.com/fdPWqne.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/dskullys",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.com/invite/dskullys"
    },
    "slug": "dskullys"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/hu4jyHl.png",
    "logoUrl": "https://i.imgur.com/hu4jyHl.png",
    "name": "SolPunks",
    "profileImageUrl": "https://i.imgur.com/hu4jyHl.png",
    "themes": ["dark"],
    "social": {
      "twitterUrl": "https://twitter.com/PunksOnSolana/",
      "marketplaceUrl": "https://solanart.io/collections/solpunks?tab=items",
      "discordUrl": "https://discord.gg/solpunks"
    },
    "slug": "solpunks",
    "backgroundImage": "https://i.imgur.com/qB5jwba.png"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/nuiia9i.png",
    "logoUrl": "https://i.imgur.com/nuiia9i.png",
    "name": "The Stoners",
    "profileImageUrl": "https://i.imgur.com/nuiia9i.png",
    "themes": ["dark"],
    "social": {
      "twitterUrl": "https://twitter.com/thestonersonsol",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/thestoners"
    },
    "slug": "thestoners",
    "backgroundImage": "https://i.imgur.com/cgFkt0W.png"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/ODzYy2w.png",
    "logoUrl": "https://i.imgur.com/ODzYy2w.png",
    "name": "POMPEIZZ",
    "profileImageUrl": "https://i.imgur.com/ODzYy2w.png",
    "themes": ["light"],
    "social": {
      "twitterUrl": "https://twitter.com/Pompeizz",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/pompeizz"
    },
    "slug": "pompeizz",
    "backgroundImage": "https://i.imgur.com/Txaq9NI.png"
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/iySL4G5.png",
    "logoUrl": "https://i.imgur.com/iySL4G5.png",
    "name": "Sol Playboy",
    "profileImageUrl": "https://i.imgur.com/iySL4G5.png",
    "themes": ["dark", "light"],
    "social": {
      "twitterUrl": "https://twitter.com/degencoinflip",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "solplayboy",
  },
  {
    "id": "00000000-0000-0000-0000-000000042069",
    "coinImageUrl": "https://i.imgur.com/je1EGd3.png",
    "logoUrl": "https://i.imgur.com/je1EGd3.png",
    "name": "TreasuryDAO",
    "profileImageUrl": "https://i.imgur.com/je1EGd3.png",
    "themes": ["light", "dark"],
    "social": {
      "twitterUrl": "https://twitter.com/degencoinflip",
      "marketplaceUrl": "https://magiceden.io/marketplace/degen_coin_flip",
      "discordUrl": "https://discord.gg/GnNacaEAyP"
    },
    "slug": "thetreasury",
    "backgroundImage": "https://i.imgur.com/clf6GRG.gif",
    "backgroundImageDark": "https://i.imgur.com/RbFx2nn.gif"
  },
]

export const constants = {
  LOGO: {
    Default: "https://i.imgur.com/896fn7R.png",
    Whale: "https://i.imgur.com/phpvKTj.png"
    // Default: "https://i.imgur.com/PcpvtJg.png"
  },
  BUTTONS: {
    DoubleOrNothing: "https://i.imgur.com/gMlDK1J.png",
    Yolo: "https://i.imgur.com/kfsT8We.png",
    ClaimReward: "https://i.imgur.com/68rdjJv.png",
    Heads: "https://i.imgur.com/wc7Ci3f.png",
    Tails: "https://i.imgur.com/wxXcGls.png",
    TwoSol: "https://i.imgur.com/eS5gbgf.png",
    OneSol: "https://i.imgur.com/D8b7RNF.png",
    PtOneSol: "https://i.imgur.com/o6IEhiu.png",
    PtFiveSol: "https://i.imgur.com/iChJqD2.png",
    Pt25Sol: "https://i.imgur.com/5lRVCML.png",
    CoinHeads: "https://i.imgur.com/vQqakuK.png",
    CoinTails: "https://i.imgur.com/cFEB8Wg.png",
    ClaimFee: "https://i.imgur.com/rKnaYP9.png",
    BabyCoin: "https://i.imgur.com/AUUGX4z.gif",
    BabyCoinButt: "https://i.imgur.com/pp6kuh9.gif",
    BabyButton: "https://i.imgur.com/LnRn1mC.png",
    TryAgain: "https://i.imgur.com/Qvq0Dvg.png",
    PleaseWait: "https://i.imgur.com/x1WRFzM.png",
    Processing: "https://i.imgur.com/2n0q9IX.gif",
    Donate: "https://i.imgur.com/UbMA9Me.png"
  },
  BUTTONS_WHALE: {
    DoubleOrNothing: "https://i.imgur.com/iei8BiD.png",
    ClaimReward: "https://i.imgur.com/wSyr8pq.png",
    PleaseWait: "https://i.imgur.com/4ZGvTxv.png",
    Heads: "https://i.imgur.com/xSjfP8z.png",
    Tails: "https://i.imgur.com/v3MBBQL.png",
    OneSol: "https://i.imgur.com/mMn3Lpj.png",
    TwoSol: "https://i.imgur.com/2WaNhj6.png",
    ThreeSol: "https://i.imgur.com/KMr8vDX.png"
  },
  GIFS: {
    CoinSide: "https://i.imgur.com/VxoSlqK.gif"
  }
}

export const ERRORS = {
  DEPOSIT_FAILED: {
    code: 1001,
    type: "Solana Network Message",
    message: "Your SOL was not deposited. Wait a moment, and try again."
  },
  REWARD_PROCESSING: {
    code: 1002,
    type: "Solana Network Error",
    message: "Your SOL reward is still processing. Wait a moment, and try again.",
  },
  FLIP_FAILED: {
    code: 1002,
    type: "Uh no!",
    message: "Something went wrong. Click double or nothing, and try again.",
  },
  PREV_PROCESSING: {
    code: 1003,
    type: "Please Wait",
    message: "Sorry! Solana is still processing your previous coin flip...",
  },
  DONATION_FAILED: {
    code: 1004,
    type: "Uh Oh",
    message: "Your SOL could not be deposited. Please check your balance and try again. ",
  }
}

export const CoinFlipStatus = {
  STARTED: "STARTED",
  FINALIZED: "FINALIZED",
  FINALIZE_REQUESTED: "FINALIZE_REQUESTED",
  PROCESSING: "PROCESSING"
};


export const opposite = (side: any) => {
  if (side === "H") return "T";
  return "H";
}

export const CharityBounty = {
  UKRAINE: "ukraine"
};

export const VALID_AMOUNTS = [0.05, 0.1, 0.25, 0.5, 1, 2, 3];

export const DistributionStatus = {
  FINALIZED: "FINALIZED",
  PROCESSING: "PROCESSING",
  STARTED: "STARTED",
  CANCELED: "CANCELED"
};

export const MINT_PRICE = 0.99969;
